<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              2024 Veritas Crew and Family Parties - Cebu and Bohol
            </h2>
            <p class="vmc-text-primary-2 letter-spacing-1 mb-0">
              By Veritas Admin — December 01, 2024
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center pt-4">
            <p class="my-3 text-left">
              Veritas Maritime Corporation held its annual Crew and Family Parties, in advance celebration of the holiday season, across several Provincial Chapters.  Activities commenced from October 26 to 28, 2024 in Cebu and Bohol.            </p>

            <p class="text-left my-3">
              We started with Cebu Party last October 26 at Maayo Hotel, and Bohol Party last October 27 at Bohol Tropics Hotel.  Both events were well attended, Cebu with 181 attendees (18 crew/51 allottees/112 family and guests) and 297 for Bohol (20 crew/82 allottees/195 family and guests). Events were also participated by representatives from KRBS with KRBS-KOBE Crewing Group Mr. Sanshiro Kobayashi, KRBS-ROHQ Managing Director Mr. Hitoshi Koshikawa, and KRBS-ROHQ OCHG Mr. Jun Ragos, and from KSK, General Manager Mr. Makoto Goto.
            </p>

            <p class="text-left my-3">
              Both parties were inspired with the messages of our Principals, our Chairman Mr. Ericson Marquez in Cebu, and President Mr. Jiro Marquez in Bohol.  The programs included a segment on business updates and information sharing from Veritas management and from KRBS-ROHQ. Our long serving crew were also given special recognition, particularly in Cebu to retired OLR1 Glen M. Potot, 29 years of service, but had to retire due to his medical/physical condition that led to having his leg amputated. Special citation was given to him and his family who were all present during the Cebu party.
            </p>

            <p class="text-left my-3">
              During the last day in Bohol on October 28, our delegates visited the School Clinic that is now completely built as part of our CSR activity from last year, through the initiative of our Bohol Allottee Officers, and generous efforts of our Principals and Veritas Management. A short inauguration ceremony was held, with some food and candies handed out by our delegates to 108 school children.
            </p>

            <div class="d-flex justify-content-center flex-wrap">
              <div class="m-1">
                <img :src="section1" alt="" class="border pl-1" style="height: auto; width: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VmcCrewFamilyParty2024CebuBohol",
  data(){
    return {
      section1 : require(`@/assets/news/2024/CebuBohol2024.jpg`)
    }
  }
}
</script>

<style scoped>

</style>
